import type { ChatMessageDocument } from '@models/chat';
import type { UserDocument } from '@models/user';
import MessageContent from './MessageContent';
import MessageImage from './MessageImage';
import MessageProduct from './MessageProduct';
import MessageTimestamp from './MessageTimestamp';
import { cn } from '@util/index';

interface MessageOutboundProps {
  message: ChatMessageDocument;
  timestamp: number;
  isSupport?: boolean;
  user?: UserDocument | null;
  fallbackImg?: string;
  onImageClick: (image: string) => void;
  onRightClick?: (ev: React.MouseEvent) => void;
  isSidebar?: boolean;
}

export default function MessageOutbound({
  message,
  timestamp,
  fallbackImg,
  onImageClick,
  onRightClick,
  isSidebar,
}: MessageOutboundProps) {
  const hasProductLink = message.content.includes(
    `https://${
      process.env.NEXT_PUBLIC_IS_STAGING ? 'mxlocker.dev' : 'mxlocker.com'
    }/product/`
  );

  const productSlug = hasProductLink
    ? message.content.split('/')[message.content.split('/').length - 1]
    : '';

  return (
    <div
      className={cn(
        'flex flex-col items-end gap-[1.6rem] justify-self-end font-medium',
        isSidebar ? 'sm:max-w-[30rem]' : 'max-w-[30rem] sm:max-w-[50rem]'
      )}
    >
      {!message.is_img ? (
        <div className="flex flex-col items-end gap-[0.4rem]">
          <MessageTimestamp timestamp={timestamp} isOutbound={true} />

          {hasProductLink && <MessageProduct slug={productSlug} />}

          <MessageContent
            content={message.content}
            isOutbound={true}
            className="self-end"
            isSidebar={isSidebar}
            onRightClick={onRightClick}
          />
        </div>
      ) : (
        <MessageImage
          message={message}
          img={message.thumbnail ?? message.content}
          fallbackImg={message.download_url ?? fallbackImg}
          onClick={onImageClick}
          onRightClick={onRightClick}
        />
      )}
    </div>
  );
}
